import React from 'react';
import styled from 'styled-components';
import { CabinetWidgetTemplate } from '../templates';
import { MenuWithToggle, License, Balance, Profile } from '../organisms';
import { WidgetCabinetButton, WidgetStoreButton, WidgetButtons } from '../atoms';
import { compose, withHandlers, lifecycle } from 'recompose';
import { ls } from '@lib/local-storage';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import i18n from '@i18n/i18n';
import { connect } from 'react-redux';
import { selectUserData, selectUserGoods, selectTeamLicenses, selectUserAvatar, selectFreeSpace } from '../selectors';
import * as effects from '../../common/effects';
import { POP_CURRENT_TEAM } from '@constants';

const mapStateToProps = (state) => ({
  id: selectUserData(state).id,
  teamId: selectUserData(state).currentTeam,
  userAvatar: selectUserData(state).avatar,
  avatar: selectUserAvatar(state).avatar,
  tariff: selectUserData(state).tariff,
  username: selectUserData(state).username,
  currentTeam: selectUserData(state).currentTeam,
  teams: selectUserData(state).teams,
  goods: selectUserGoods(state),
  licenseCount: selectTeamLicenses(state).licenseCount,
  licenseExpire: selectTeamLicenses(state).licenseExpire,
  quotaUsage: selectFreeSpace(state).quotaUsage,
  quotaFree: selectFreeSpace(state).quotaFree,
  quotaLimit: selectFreeSpace(state).quotaLimit,
  hasQuota: selectFreeSpace(state).hasQuota,
});

const mapDispatchToProps = {
  fetchData: effects.fetchUser,
  setCurrentTeam: effects.setCurrentTeam,
};

const enchance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    setCurrentTeam: ({ id, setCurrentTeam }) => (data) => {
      if (!window._cabinetWidgetConnected) {
        const lang = window._lang ? '/' + window._lang : '';

        ls.setItem(id + '.currentTeam', data);
        ls.setItem(POP_CURRENT_TEAM, data);

        setTimeout(() => {
          window.location = `${lang}/cabinet/`;
        });
      }

      setCurrentTeam(data);
    },
    onLogout: ({ id }) => (onClose) => {
      onClose();
      ls.setItem(id + '.currentTeam', null);
      ls.removeItem(POP_CURRENT_TEAM);
      document.cookie = 'POP_SESSION=;max-age=0;path=/';
      window.location = '/logout';
    },
    openStore: ({ teamId }) => () => {
      window.uiStore.open({
        team_id: teamId,
      });
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchData();
    },
  })
);

const CabinetWidgetView = ({
  avatar,
  userAvatar,
  goods,
  licenseCount,
  licenseExpire,
  username,
  teams,
  currentTeam,
  setCurrentTeam,
  onLogout,
  tariff,
  quotaUsage,
  quotaFree,
  quotaLimit,
  hasQuota,
  openStore,
}) => (
  <I18nextProvider i18n={i18n}>
    <WidgetButtons>
      <WidgetStoreButton onClick={openStore}>{i18next.t('cabinet.widget.store')}</WidgetStoreButton>
      <MenuWithToggle
        button={(onClick) => (
          <WidgetCabinetButton onClick={onClick} href={`/${window._lang}/cabinet`} avatar={avatar}>
            {i18next.t('cabinet.widget.cabinet')}
          </WidgetCabinetButton>
        )}
        fade={true}
        render={(onClose) => (
          <Menu>
            <CabinetWidgetTemplate
              license={
                <License
                  quotaUsage={quotaUsage}
                  quotaFree={quotaFree}
                  quotaLimit={quotaLimit}
                  hasQuota={hasQuota}
                  tariff={tariff}
                  count={licenseCount}
                  expire={licenseExpire}
                  onClose={onClose}
                  goods={goods}
                />
              }
              balance={<Balance goods={goods} onClose={onClose} currentTeam={currentTeam} openStore={openStore} />}
              profile={
                <Profile
                  username={username}
                  avatar={userAvatar}
                  teams={teams}
                  currentTeam={currentTeam}
                  setCurrentTeam={setCurrentTeam}
                  onLogout={onLogout}
                  onClose={onClose}
                />
              }
            />
          </Menu>
        )}
      />
    </WidgetButtons>
  </I18nextProvider>
);

export const CabinetWidget = enchance(CabinetWidgetView);

const Menu = styled.div`
  background: none;
  border: 0;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-top: 8px;
  text-align: left;
`;
